'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import SvgChevronright from '@common/icon/SvgChevronright';
import { AnimatePresence, motion } from 'framer-motion';
import { type ReactNode, useEffect } from 'react';
import { VERIFICATION_TYPE } from '@/api';
import { BREAKPOINTS, DONATION_ROUTES, ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
import { useFade } from '../../_utils/motion';
import type { GateDialog } from '../_utils/resolveGateDialogList';
const LINE_BREAK = <br className="lg:hidden" />;
export const GateDialogModal = t0 => {
  const $ = _c(51);
  const {
    campaignId,
    dialog,
    onClose,
    onLeave,
    verifyRedirect: t1
  } = t0;
  let t2;
  if ($[0] !== campaignId || $[1] !== t1) {
    t2 = t1 === undefined ? DONATION_ROUTES.GIFT_TRIAL_DETAIL.pathname({
      campaignId
    }) : t1;
    $[0] = campaignId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const verifyRedirect = t2;
  const router = useCustomRouter();
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP);
  const buttonDimensions = isDesktopViewport ? "H56" : "H48";
  const fade = useFade();
  let t3;
  if ($[3] !== dialog?.type || $[4] !== fade) {
    t3 = (node, className) => <AnimatePresence mode="wait" initial={false}><motion.span key={dialog?.type} className={className} {...fade()}>{node}</motion.span></AnimatePresence>;
    $[3] = dialog?.type;
    $[4] = fade;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const crossFade = t3;
  let t4;
  bb0: switch (dialog?.type) {
    case "verify":
      {
        let t5;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <>체험단 참여를 위해<br />본인인증이 필요해요!</>;
          t6 = <>최초 1회만 인증하면 바로 {LINE_BREAK}참여할 수 있어요.</>;
          $[6] = t5;
          $[7] = t6;
        } else {
          t5 = $[6];
          t6 = $[7];
        }
        let t7;
        if ($[8] !== onLeave || $[9] !== router || $[10] !== verifyRedirect) {
          t7 = () => {
            router.push(ROUTES.EASY_CERTIFICATION.withSearchParams({
              searchParams: {
                verification: VERIFICATION_TYPE.PROFILE_UPDATE,
                isNotUseCertificateCache: "Y",
                redirect: verifyRedirect
              }
            }));
            onLeave();
          };
          $[8] = onLeave;
          $[9] = router;
          $[10] = verifyRedirect;
          $[11] = t7;
        } else {
          t7 = $[11];
        }
        let t8;
        if ($[12] !== buttonDimensions || $[13] !== t7) {
          t8 = <Button dimensions={buttonDimensions} onClick={t7}>본인 인증하기</Button>;
          $[12] = buttonDimensions;
          $[13] = t7;
          $[14] = t8;
        } else {
          t8 = $[14];
        }
        t4 = {
          title: t5,
          description: t6,
          footer: t8
        };
        break bb0;
      }
    case "review":
      {
        const {
          applicationId
        } = dialog;
        let t5;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <>후기 작성이 완료되어야 {LINE_BREAK}새로운 체험단에 신청할 수 있어요.</>;
          $[15] = t5;
        } else {
          t5 = $[15];
        }
        let t6;
        if ($[16] !== applicationId || $[17] !== onLeave || $[18] !== router) {
          t6 = () => {
            router.push(DONATION_ROUTES.GIFT_TRIAL_REVIEW.pathname({
              applicationId
            }));
            onLeave();
          };
          $[16] = applicationId;
          $[17] = onLeave;
          $[18] = router;
          $[19] = t6;
        } else {
          t6 = $[19];
        }
        let t7;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <SvgChevronright aria-hidden={true} className="size-16" />;
          $[20] = t7;
        } else {
          t7 = $[20];
        }
        let t8;
        if ($[21] !== buttonDimensions || $[22] !== t6) {
          t8 = <Button dimensions={buttonDimensions} onClick={t6}>후기 작성하기{t7}</Button>;
          $[21] = buttonDimensions;
          $[22] = t6;
          $[23] = t8;
        } else {
          t8 = $[23];
        }
        t4 = {
          title: "\uC774\uC804 \uB2F5\uB840\uD488 \uD6C4\uAE30\uB97C \uC791\uC131\uD574\uC8FC\uC138\uC694!",
          description: t5,
          footer: t8
        };
        break bb0;
      }
    case "delivery":
      {
        let t5;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <>배송 완료 후 후기를 작성하면 {LINE_BREAK}새로운 체험단에 신청할 수 있어요.</>;
          $[24] = t5;
        } else {
          t5 = $[24];
        }
        let t6;
        if ($[25] !== buttonDimensions || $[26] !== onClose) {
          t6 = <Button theme="sub-text" dimensions={buttonDimensions} onClick={onClose}>닫기</Button>;
          $[25] = buttonDimensions;
          $[26] = onClose;
          $[27] = t6;
        } else {
          t6 = $[27];
        }
        let t7;
        if ($[28] !== onLeave || $[29] !== router) {
          t7 = () => {
            router.push(DONATION_ROUTES.GIFTS.pathname);
            onLeave();
          };
          $[28] = onLeave;
          $[29] = router;
          $[30] = t7;
        } else {
          t7 = $[30];
        }
        let t8;
        if ($[31] !== buttonDimensions || $[32] !== t7) {
          t8 = <Button dimensions={buttonDimensions} onClick={t7}>다른 답례품 보러가기</Button>;
          $[31] = buttonDimensions;
          $[32] = t7;
          $[33] = t8;
        } else {
          t8 = $[33];
        }
        let t9;
        if ($[34] !== t6 || $[35] !== t8) {
          t9 = <>{t6}{t8}</>;
          $[34] = t6;
          $[35] = t8;
          $[36] = t9;
        } else {
          t9 = $[36];
        }
        t4 = {
          title: "\uCCB4\uD5D8 \uC911\uC778 \uB2F5\uB840\uD488\uC774 \uC788\uC5B4\uC694",
          description: t5,
          footer: t9
        };
        break bb0;
      }
    default:
      {
        t4 = null;
      }
  }
  const content = t4;
  useOverlayHistory(Boolean(content), onClose);
  let t5;
  if ($[37] !== dialog?.type || $[38] !== router) {
    t5 = () => {
      if (dialog?.type === "delivery") {
        router.prefetch(DONATION_ROUTES.GIFTS.pathname);
      }
    };
    $[37] = dialog?.type;
    $[38] = router;
    $[39] = t5;
  } else {
    t5 = $[39];
  }
  const t6 = dialog?.type;
  let t7;
  if ($[40] !== router || $[41] !== t6) {
    t7 = [t6, router];
    $[40] = router;
    $[41] = t6;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  useEffect(t5, t7);
  const T0 = Modal;
  const t8 = Boolean(content);
  const t9 = dialog?.type !== "delivery";
  const t10 = content ? crossFade(content.title) : undefined;
  const t11 = "typo-body2 lg:font-800 lg:typo-h5";
  const t12 = content ? crossFade(content.description) : undefined;
  const t13 = content ? crossFade(content.footer, "flex flex-1 flex-col-reverse gap-2 lg:flex-row lg:gap-8 [&>*]:flex-1") : undefined;
  let t14;
  if ($[43] !== T0 || $[44] !== onClose || $[45] !== t10 || $[46] !== t12 || $[47] !== t13 || $[48] !== t8 || $[49] !== t9) {
    t14 = <T0 opened={t8} onClose={onClose} closeButton={t9} header={t10} headerClassName={t11} description={t12} buttonFooter={t13} />;
    $[43] = T0;
    $[44] = onClose;
    $[45] = t10;
    $[46] = t12;
    $[47] = t13;
    $[48] = t8;
    $[49] = t9;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  return t14;
};